import { render, staticRenderFns } from "./TagFormFields.vue?vue&type=template&id=1b43f493&scoped=true"
import script from "./TagFormFields.vue?vue&type=script&lang=ts"
export * from "./TagFormFields.vue?vue&type=script&lang=ts"
import style0 from "./TagFormFields.vue?vue&type=style&index=0&id=1b43f493&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b43f493",
  null
  
)

export default component.exports